import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon } from 'lucide-react';
import { OCCASIONS } from '../data/smaken';
import { CITY_GUIDES } from '../data/guide';
import { SHOP_CATEGORIES } from '../data/shop';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="w-full bg-black text-papper" data-id="element-414" data-mp="36oy0x9h17x22">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-24" data-id="element-415" data-mp="36nd4tff2k623">
        <div className="grid gap-14 md:grid-cols-[1.3fr,1fr,1fr,1fr]" data-id="element-416" data-mp="3ugbsveb9tqmi">
          <div data-id="element-417" data-mp="3990ijjp5eap">
            <Logo tone="block" className="h-14 md:h-16" data-id="element-418" data-mp="37o7wzgy05fh" />
            <p className="mt-6 font-hand text-3xl text-papper/80" data-id="element-419" data-mp="3lecbgkwcgkj1">Smaken som baken.</p>
            <p className="mt-4 max-w-xs leading-relaxed text-papper/55" data-id="element-420" data-mp="3lgop4lv2k8qa">
              Catering, guide och butik. Som en kompis som vet var det finns något gott.
            </p>
          </div>

          <nav aria-label="Catering" data-id="element-421" data-mp="2a19uhoqc1syc">
            <p className="text-[11px] font-bold uppercase tracking-wide3 text-papper/40" data-id="element-422" data-mp="2eyt94pqy07qt">Catering</p>
            <ul className="mt-5 space-y-2.5" data-id="element-423" data-mp="3l90pe0juz71d">
              <li data-id="element-424" data-mp="3l9si93m2mqny">
                <Link to="/catering" className="font-display text-xl uppercase transition-colors duration-150 ease-out hover:text-rod" data-id="element-425" data-mp="3lbdc0r0ka5kr">
                  Allt utbud
                </Link>
              </li>
              {OCCASIONS.map(o => <li key={o} data-id="element-426" data-mp="3qazq12o7rpum">
                  <Link to={`/catering?tillfalle=${o}`} className="text-sm text-papper/70 transition-colors duration-150 ease-out hover:text-papper" data-id="element-427" data-mp="82ihs7hrf0lp">
                    {o}
                  </Link>
                </li>)}
              <li data-id="element-428" data-mp="ct76jf221jh5">
                <Link to="/forfragan" className="text-sm text-papper/70 transition-colors duration-150 ease-out hover:text-papper" data-id="element-429" data-mp="cus1v6w716g2">
                  Din förfrågan
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Guiden och butiken" data-id="element-430" data-mp="tvw7cfth7dfg">
            <p className="text-[11px] font-bold uppercase tracking-wide3 text-papper/40" data-id="element-431" data-mp="tt09ssljiqrj">Guiden</p>
            <ul className="mt-5 space-y-2.5" data-id="element-432" data-mp="ys3fmf9ch10k">
              <li data-id="element-433" data-mp="13t0twgr8haws">
                <Link to="/guide" className="font-display text-xl uppercase transition-colors duration-150 ease-out hover:text-rod" data-id="element-434" data-mp="13sirf2dza0gf">
                  Städerna
                </Link>
              </li>
              {CITY_GUIDES.map(g => <li key={g.city} data-id="element-435" data-mp="1hje30mfv2vnp">
                  <Link to={`/guide/${g.city.toLowerCase()}`} className="text-sm text-papper/70 transition-colors duration-150 ease-out hover:text-papper" data-id="element-436" data-mp="1hms4ztkm52um">
                    {g.city}
                  </Link>
                </li>)}
            </ul>

            <p className="mt-8 text-[11px] font-bold uppercase tracking-wide3 text-papper/40" data-id="element-437" data-mp="3t9yijqx6ik36">Butiken</p>
            <ul className="mt-5 space-y-2.5" data-id="element-438" data-mp="2aevg9zetc08y">
              <li data-id="element-439" data-mp="2agokz95v8aeb">
                <Link to="/butik" className="font-display text-xl uppercase transition-colors duration-150 ease-out hover:text-rod" data-id="element-440" data-mp="2ah86t0ymzixm">
                  Handla
                </Link>
              </li>
              {SHOP_CATEGORIES.slice(0, 3).map(c => <li key={c} data-id="element-441" data-mp="1wlw0dwb4c40v">
                  <Link to={`/butik?kategori=${c}`} className="text-sm text-papper/70 transition-colors duration-150 ease-out hover:text-papper" data-id="element-442" data-mp="2tehp2es86qda">
                    {c}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-443" data-mp="2fdf1fxll1809">
            <p className="text-[11px] font-bold uppercase tracking-wide3 text-papper/40" data-id="element-444" data-mp="2fdow3yhko3ca">För företag</p>
            <ul className="mt-5 space-y-2.5 text-sm text-papper/75" data-id="element-445" data-mp="18zfr2qb78upn">
              <li data-id="element-446" data-mp="13y042spgoe4m">
                <Link to="/bli-en-del" className="transition-colors duration-150 ease-out hover:text-papper" data-id="element-447" data-mp="13xgohinaa1tr">
                  Bli en del av Småken
                </Link>
              </li>
              <li data-id="element-448" data-mp="2wn98q4584r0u">
                <Link to="/upptack" className="transition-colors duration-150 ease-out hover:text-papper" data-id="element-449" data-mp="2wnr3ewc8mx6n">
                  Alla ställen
                </Link>
              </li>
              <li data-id="element-450" data-mp="2nuxler5epjp3">
                <Link to="/om" className="transition-colors duration-150 ease-out hover:text-papper" data-id="element-451" data-mp="2nue49cnkyzc4">
                  Om Småken
                </Link>
              </li>
              <li data-id="element-452" data-mp="3fk0ow4pgyq0o">
                <Link to="/admin" className="transition-colors duration-150 ease-out hover:text-papper" data-id="element-453" data-mp="3fkiuhry0ugl9">
                  Logga in
                </Link>
              </li>
              <li data-id="element-454" data-mp="36jkox57xq10k">
                <a href="mailto:hej@smaken.se" className="transition-colors duration-150 ease-out hover:text-papper" data-id="element-455" data-mp="36j2jbhzduafz">
                  hej@smaken.se
                </a>
              </li>
            </ul>

            <a href="https://instagram.com" className="mt-7 inline-flex items-center gap-2 text-sm text-papper/75 transition-colors duration-150 ease-out hover:text-papper" data-id="element-456" data-mp="1nlfzbll4vssu">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-457" data-mp="1wlkw71spb8sr" />
              Instagram
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-papper/15 pt-7 text-[11px] uppercase tracking-wide2 text-papper/40 sm:flex-row" data-id="element-458" data-mp="1rlgex9jyya1h">
          <p data-id="element-459" data-mp="zxekxw19xi5i">Gjord i Småland. För alla som gillar det goda.</p>
          <p data-id="element-460" data-mp="1dni1q7hdwjnk">© {new Date().getFullYear()} Smaken som baken — kalla oss Småken</p>
        </div>
      </div>
    </footer>;
}